Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
};

Storage.prototype.getObject = function(key) {
  const value = this.getItem(key);
  return value && JSON.parse(value);
};

// Local storage setters
export function setAuthInfo(authInfo) {
  if (authInfo) {
    if (authInfo.user) {
      localStorage.setObject("userInfo", authInfo.user);
    }
    if (authInfo.auth) {
      if (
        authInfo.auth.refresh_token &&
        authInfo.auth.refresh_token_expires_at
      ) {
        localStorage.setObject("refreshTokenInfo", {
          refresh_token: authInfo.auth.refresh_token,
          refresh_token_expires_at: authInfo.auth.refresh_token_expires_at
        });
      }
    }
  }
}

export function setRefreshTokenInfo(authInfo) {
  if (authInfo) {
    if (authInfo.refresh_token && authInfo.refresh_token_expires_at) {
      localStorage.setObject("refreshTokenInfo", {
        refresh_token: authInfo.refresh_token,
        refresh_token_expires_at: authInfo.refresh_token_expires_at
      });
    }
  }
}

export function setLocale(locale) {
  localStorage.setItem("userLocale", locale);
}

// Local storage getters
export function getUserInfo() {
  return localStorage.getObject("userInfo");
}

export function getUserLocale() {
  return localStorage.getItem("userLocale");
}
export function isUserAuth() {
  return !!localStorage.getItem("userInfo");
}

export function getRefreshTokenInfo() {
  return localStorage.getObject("refreshTokenInfo");
}

export function getUserStatus() {
  return localStorage.getItem("userStatus");
}

export function getUserID() {
  const userInfo = localStorage.getObject("userInfo");
  if (userInfo) {
    if (userInfo.id) {
      return userInfo.id;
    }
  }
  return null;
}

export function getRefreshTokenExpTime() {
  const refreshTokenInfo = localStorage.getObject("refreshTokenInfo");
  if (refreshTokenInfo) {
    if (refreshTokenInfo.refresh_token_expires_at) {
      return refreshTokenInfo.refresh_token_expires_at;
    }
  }
  return null;
}

export function getRefreshToken() {
  const refreshTokenInfo = localStorage.getObject("refreshTokenInfo");
  if (refreshTokenInfo) {
    if (refreshTokenInfo.refresh_token) {
      return refreshTokenInfo.refresh_token;
    }
  }
  return null;
}

export function clearStorage() {
  const userLocale = localStorage.getItem("userLocale");
  localStorage.clear();
  localStorage.setItem("userLocale", userLocale);
}
